import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="colophon">
      <div className="wrap">
        <div className="cols">
          <div>
            <h4>Gapsmiths Consulting LLP</h4>
            <address>
              Mumbai, Maharashtra<br />
              India
            </address>
          </div>
          <div>
            <h4>Get in touch</h4>
            <ul>
              <li><a href="mailto:vivek@gapsmiths.com">vivek@gapsmiths.com</a></li>
              <li><a href="tel:+919323029857">+91 93230 29857</a></li>
            </ul>
          </div>
          <div>
            <h4>Policies</h4>
            <ul>
              <li><Link to="/terms">Terms &amp; Conditions</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
            </ul>
          </div>
        </div>
        <p className="legalline">
          Gapsmiths Consulting LLP &nbsp;·&nbsp; GSTIN 27AAPFG1889E1Z0 &nbsp;·&nbsp; © 2026 All rights reserved.
        </p>
      </div>
    </footer>
  );
}
